"use client";
import { env } from "@/lib/env";
import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(env.NEXT_PUBLIC_MUI_KEY || "");

export default function MuiXLicense() {
  return null;
}
